import { CustomColumn } from '../../types/customColumn';
import { ICustomer } from '../../types/customer/customerInterfaces';

export const customerColumns: CustomColumn<ICustomer>[] = [
  /**
   * 👤 Cliente
   */
  {
    Header: 'Cliente',
    accessor: 'name',
    customCell: ({ row }) => (
      <div className="min-w-[240px] max-w-[320px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.name || '—'}
        </div>

        {row.original.defaultCustomer && (
          <span className="mt-1 inline-flex rounded-full bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary">
            Predeterminado
          </span>
        )}

        <div
          className="
            text-gray-500
            dark:text-gray-400
            mt-1
            whitespace-normal
            break-words
            text-xs
            leading-5
          "
        >
          {row.original.entityTypeName || '—'} ·{' '}
          {row.original.taxpayerCategoryName || '—'}
        </div>
      </div>
    ),
  },

  /**
   * 🪪 Documento
   */
  {
    Header: 'Documento',
    accessor: 'document',
    customCell: ({ row }) => (
      <div className="min-w-[180px]">
        <span className="font-medium text-black dark:text-white">
          {row.original.document || '—'}
        </span>
      </div>
    ),
  },

  /**
   * 📞 Contacto
   */
  {
    Header: 'Contacto',
    accessor: 'phone',
    customCell: ({ row }) => (
      <div className="min-w-[220px] max-w-[280px]">
        <div className="text-gray-700 dark:text-gray-300 text-sm font-medium">
          {row.original.phone || '—'}
        </div>

        <div
          className="
            text-gray-500
            dark:text-gray-400
            mt-1
            whitespace-normal
            break-words
            text-xs
            leading-5
          "
        >
          {row.original.email || '—'}
        </div>
      </div>
    ),
  },

  /**
   * ✅ Estado
   */
  {
    Header: 'Estado',
    accessor: 'status',
    customCell: ({ row }) => (
      <div className="min-w-[140px]">
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            row.original.status
              ? 'bg-green-500 text-white'
              : 'bg-[#DC3545] text-white'
          }`}
        >
          {row.original.status ? 'Activo' : 'Inactivo'}
        </span>
      </div>
    ),
  },
];
